/* SSi website – Korean landing page hero. Mirrors SpanishHero.jsx — same A/B variants. */
import { Link } from 'react-router-dom';

export function KoreanHero({ onStart, t }) {
  const variant = t.koHeroVariant || 'A';
  return variant === 'B'
    ? <KoreanHeroB onStart={onStart} t={t}/>
    : <KoreanHeroA onStart={onStart} t={t}/>;
}

function KoreanHeroA({ onStart, t }) {
  return (
    <section className="ssi-koHero ssi-koHero--A" style={koHeroStyles.wrapA}>
      <div className="ssi-koHero__leftA" style={koHeroStyles.leftA}>
        {t.koHeroKicker && <div style={koHeroStyles.kicker}>{t.koHeroKicker}</div>}
        <h1 style={koHeroStyles.h1}>{t.koHeroTitle}</h1>
        <p style={koHeroStyles.lede}>{t.koHeroSub1}</p>
        <p style={koHeroStyles.lede}>{t.koHeroSub2}</p>
        <div style={koHeroStyles.ctas}>
          <Link to="/pay?course=en-ko" className="btn btn--onDark">{t.koHeroCta1}</Link>
          <a href="#sample" className="btn" style={koHeroStyles.ghost}>{t.koHeroCta2}</a>
        </div>
        <p style={koHeroStyles.trust}>{t.koHeroTrust}</p>
      </div>
      <div className="ssi-koHero__rightA" style={koHeroStyles.rightA}>
        <img src="/assets/hero_man_waving.png?v=6" alt="" style={koHeroStyles.heroImg}/>
        <div className="ssi-koHero__bubble" style={koHeroStyles.bubble} aria-hidden>
          <span style={koHeroStyles.bubbleWord}>{t.koHeroBubble || "안녕!"}</span>
          <span style={koHeroStyles.bubbleTail}/>
        </div>
      </div>
    </section>
  );
}

function KoreanHeroB({ onStart, t }) {
  return (
    <section className="ssi-koHero ssi-koHero--B" style={koHeroStyles.wrapB}>
      <div className="ssi-koHero__innerB" style={koHeroStyles.innerB}>
        <div className="ssi-koHero__giantWrap" style={koHeroStyles.giantWrap}>
          <span style={koHeroStyles.giantTranslate}>(verb) to speak — malhagi</span>
          <div style={koHeroStyles.giant} aria-hidden>{t.koHeroGiantWord}</div>
          <div style={koHeroStyles.giantUnderline}/>
        </div>
        <div style={koHeroStyles.copyB}>
          {t.koHeroKicker && <div style={koHeroStyles.kickerB}>{t.koHeroKicker}</div>}
          <h1 style={koHeroStyles.h1B}>{t.koHeroTitle}</h1>
          <p style={koHeroStyles.ledeB}>{t.koHeroSub1}</p>
          <p style={koHeroStyles.ledeB}>{t.koHeroSub2}</p>
          <div style={koHeroStyles.ctas}>
            <Link to="/pay?course=en-ko" className="btn btn--onDark">{t.koHeroCta1}</Link>
            <a href="#sample" className="btn" style={koHeroStyles.ghost}>{t.koHeroCta2}</a>
          </div>
          <p style={koHeroStyles.trustB}>{t.koHeroTrust}</p>
        </div>
      </div>
    </section>
  );
}

const koHeroStyles = {
  kicker: { fontSize: 12, letterSpacing: '.18em', textTransform: 'uppercase', color: '#FFD8D4', fontWeight: 600, marginBottom: 18 },
  h1: { fontFamily: 'var(--font-display)', fontSize: 64, lineHeight: 1.04, color: '#fff', letterSpacing: '-.015em', margin: '0 0 20px', textWrap: 'balance' },
  lede: { fontSize: 18, lineHeight: 1.55, color: 'rgba(255,255,255,.92)', margin: '0 0 18px', maxWidth: 540 },
  ctas: { display: 'flex', gap: 12, marginTop: 20, marginBottom: 24 },
  ghost: { background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,.5)' },
  trust: { fontSize: 13, color: 'rgba(255,255,255,.72)', margin: 0 },
  wrapA: { background: 'var(--brandRed)', color: '#fff', padding: '88px 0 88px', position: 'relative', overflow: 'hidden', minHeight: 560 },
  leftA: { maxWidth: 600, padding: '0 32px', position: 'relative', zIndex: 2 },
  rightA: { position: 'absolute', right: '-320px', top: 0, bottom: 0, width: '50%', display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', overflow: 'visible' },
  heroImg: { height: '100%', width: 'auto', objectFit: 'contain', objectPosition: 'right bottom' },
  bubble: { position: 'absolute', right: 'calc(66% + 60px)', top: 'calc(37% + 30px)', background: "#FFD84D", color: '#490300', padding: '18px 28px 22px', borderRadius: 18, transform: 'rotate(-5deg)', boxShadow: '0 18px 40px -14px rgba(0,0,0,.35), 0 2px 0 rgba(0,0,0,.08)', zIndex: 3 },
  bubbleWord: { fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 52, lineHeight: 1, letterSpacing: '-.02em', display: 'inline-block', fontStyle: 'italic' },
  bubbleTail: { position: 'absolute', right: 36, top: -12, width: 22, height: 22, background: "#FFD84D", borderTopLeftRadius: 4, transform: 'rotate(45deg)' },
  wrapB: { background: 'var(--brandRed)', color: '#fff', padding: '80px 0 88px', position: 'relative', overflow: 'hidden' },
  innerB: { maxWidth: 1240, margin: '0 auto', padding: '0 32px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 56, alignItems: 'center' },
  giantWrap: { position: 'relative' },
  giantTranslate: { display: 'inline-block', fontSize: 13, color: 'rgba(255,255,255,.7)', letterSpacing: '.02em', fontStyle: 'italic', marginBottom: 4, marginLeft: 4 },
  giant: { fontFamily: 'var(--font-display)', fontSize: 'clamp(96px, 13vw, 200px)', lineHeight: .95, fontWeight: 700, letterSpacing: '-.03em', color: '#fff', margin: 0 },
  giantUnderline: { width: 80, height: 4, background: '#FFD84D', borderRadius: 4, marginTop: 20, marginLeft: 4 },
  copyB: { maxWidth: 520 },
  kickerB: { fontSize: 12, letterSpacing: '.18em', textTransform: 'uppercase', color: '#FFD8D4', fontWeight: 600, marginBottom: 16 },
  h1B: { fontFamily: 'var(--font-display)', fontSize: 44, lineHeight: 1.1, color: '#fff', letterSpacing: '-.015em', margin: '0 0 18px', textWrap: 'balance' },
  ledeB: { fontSize: 16.5, lineHeight: 1.55, color: 'rgba(255,255,255,.92)', margin: '0 0 16px', maxWidth: 520 },
  trustB: { fontSize: 13, color: 'rgba(255,255,255,.72)', margin: 0 },
};
